import React from "react";
import { FiPlus, FiUpload, FiDownload, FiDatabase } from "react-icons/fi";

const Sidebar = ({
  onAddQuestion,
  onImport,
  onExport,
  onNappsImport,
  importDisabled,
  exportDisabled,
  nappsImportDisabled,
}) => {
  return (
    <div className="fixed right-6 top-1/3 flex flex-col space-y-4 bg-white p-2 shadow-lg rounded-lg">
      <button
        onClick={onAddQuestion}
        className="p-2 hover:bg-gray-100 rounded transition-colors"
        title="Add Question"
      >
        <FiPlus size={20} />
      </button>

      {onNappsImport && (
        <button
          onClick={onNappsImport}
          disabled={nappsImportDisabled}
          className="p-2 hover:bg-indigo-50 text-indigo-600 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          title="Import from NABS Question Bank"
        >
          <FiDatabase size={20} />
        </button>
      )}

      {onImport && (
        <button
          onClick={onImport}
          disabled={importDisabled}
          className="p-2 hover:bg-gray-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          title="Import Questions (Excel/CSV)"
        >
          <FiUpload size={20} />
        </button>
      )}

      {onExport && (
        <button
          onClick={onExport}
          disabled={exportDisabled}
          className="p-2 hover:bg-gray-100 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          title="Export Questions"
        >
          <FiDownload size={20} />
        </button>
      )}
    </div>
  );
};

export default Sidebar;
